let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("byfzO")).then(() => parcelRequire('3Q1ky'));